import React, { MouseEvent, useState } from 'react'
import { GatsbyLinkProps, Link } from 'gatsby'
import './nav-menu.scss'
import { triggerTag } from '../../../utils/taggeo'

const NavMenu = ({
  isMobile,
  toggleButton,
}: {
  isMobile: boolean | null
  toggleButton: () => void
}) => {
  return (
    <nav className="f-nav-menu">
      {isMobile ? (
        <div className="f-nav-menu__hamburger">
          <button
            className="f-nav-menu__hamburger-button"
            onClick={toggleButton}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      ) : (
        <NavMenuOptions />
      )}
    </nav>
  )
}

export default NavMenu

export const NavMenuOptions = ({
  toggleButton,
}: {
  toggleButton?: () => void
}) => {
  const handleClic = (
    event: React.MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>
  ) => {
    toggleButton && toggleButton()

    triggerTag('6A', { label: (event.target as HTMLElement).textContent })
  }
  return (
    <ul className="f-nav-menu__list">
      <li className="f-nav-menu__item">
        <Link
          onClick={handleClic}
          to="/"
          className="f-nav-menu__link"
          activeClassName="--active"
        >
          Inicio
        </Link>
      </li>
      <li className="f-nav-menu__item">
        <Link
          onClick={handleClic}
          to="/instrucciones"
          className="f-nav-menu__link"
          activeClassName="--active"
        >
          Instrucciones
        </Link>
      </li>
      <li className="f-nav-menu__item">
        <Link
          onClick={handleClic}
          to="/jugar"
          className="f-nav-menu__link"
          activeClassName="--active"
        >
          Jugar
        </Link>
      </li>
      <li className="f-nav-menu__item">
        <Link
          onClick={handleClic}
          to="/top-jugadoras"
          className="f-nav-menu__link"
          activeClassName="--active"
        >
          Top jugadoras
        </Link>
      </li>
      <li className="f-nav-menu__item">
        <Link
          onClick={handleClic}
          to="/preguntas-frecuentes"
          className="f-nav-menu__link"
          activeClassName="--active"
        >
          Preguntas frecuentes
        </Link>
      </li>
    </ul>
  )
}
